import styled from 'styled-components'
import './CurrencyInfo.scss'
import { Table } from 'react-bootstrap'
import { FooterSection, LeadingTitle } from '@components'

import { CurrencyExchange } from '@components'
import { AlertCircle } from '@icons'
import { useState, useEffect } from 'react'
import { RateExchangeAPI, ShortDescriptionAPI } from '@api'
import { useTranslation } from 'react-i18next'

const CurrencyContainer = styled.div`
  background-color: #f9f9f9;
  padding-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const CurrencyInfo = function () {
  const { t, i18n } = useTranslation()
  const [currencyUSD, setcurrencyUSD] = useState([])
  const [currencySGD, setcurrencySGD] = useState([])
  const [currencyEUR, setcurrencyEUR] = useState([])
  const [currencyAUD, setcurrencyAUD] = useState([])
  const [currencyHKD, setcurrencyHKD] = useState([])
  const [currencyJPY, setcurrencyJPY] = useState([])
  const [currencyCNY, setcurrencyCNY] = useState([])
  const [currencyGBP, setcurrencyGBP] = useState([])
  const [currencyKRW, setcurrencyKRW] = useState([])
  const [shortDesc, setShortDesc] = useState(null)
  const [lastUpdated, setlastUpdated] = useState()

  const loadCurrency = async () => {
    const { data } = await RateExchangeAPI()

    if (data.hasil) {
      // SGD
      const currencySGD = data.hasil.find(
        (value) => value.currencyAbbreviation === 'SGD'
      )
      setcurrencySGD(currencySGD ? [{ ...currencySGD }] : [])

      // USD
      const currencyUSD = data.hasil.find(
        (value) => value.currencyAbbreviation === 'USD'
      )
      setcurrencyUSD(currencyUSD ? [{ ...currencyUSD }] : [])

      // EUR
      const currencyEUR = data.hasil.find(
        (value) => value.currencyAbbreviation === 'EUR'
      )
      setcurrencyEUR(currencyEUR ? [{ ...currencyEUR }] : [])

      // AUD
      const currencyAUD = data.hasil.find(
        (value) => value.currencyAbbreviation === 'AUD'
      )
      setcurrencyAUD(currencyAUD ? [{ ...currencyAUD }] : [])

      // HKD
      const currencyHKD = data.hasil.find(
        (value) => value.currencyAbbreviation === 'HKD'
      )
      setcurrencyHKD(currencyHKD ? [{ ...currencyHKD }] : [])

      // JPY
      const currencyJPY = data.hasil.find(
        (value) => value.currencyAbbreviation === 'JPY'
      )
      setcurrencyJPY(currencyJPY ? [{ ...currencyJPY }] : [])

      // CNY
      const currencyCNY = data.hasil.find(
        (value) => value.currencyAbbreviation === 'CNY'
      )
      setcurrencyCNY(currencyCNY ? [{ ...currencyCNY }] : [])

      // GBP
      const currencyGBP = data.hasil.find(
        (value) => value.currencyAbbreviation === 'GBP'
      )
      setcurrencyGBP(currencyGBP ? [{ ...currencyGBP }] : [])

      // KRW
      const currencyKRW = data.hasil.find(
        (value) => value.currencyAbbreviation === 'KRW'
      )
      setcurrencyKRW(currencyKRW ? [{ ...currencyKRW }] : [])
    } else {
      setcurrencyUSD([])
      setcurrencySGD([])
      setcurrencyEUR([])
      setcurrencyAUD([])
      setcurrencyHKD([])
      setcurrencyJPY([])
      setcurrencyCNY([])
      setcurrencyGBP([])
      setcurrencyKRW([])
    }
  }

  const loadData = async () => {
    const { data } = await ShortDescriptionAPI({ loc: 'info_kurs' })
    setShortDesc(data.data)
  }

  const formatDate = (country) => {
    const date = new Date()
    let options = { day: 'numeric', month: 'long', year: 'numeric' }

    switch (country) {
      case 'id':
        return new Intl.DateTimeFormat('id-ID', options).format(date)
      case 'en':
        return new Intl.DateTimeFormat('en-US', options).format(date)
      default:
        return new Intl.DateTimeFormat('id-ID', options).format(date)
    }
  }

  const loadLastUpdated = () => {
    // date
    const date = formatDate(i18n.language)
    let hour = new Date().getHours()
    let minute = new Date().getMinutes()

    if (hour < 10) {
      hour = '0' + hour
    }

    if (minute < 10) {
      minute = '0' + minute
    }

    const lastUpdate = `${date} - ${hour}:${minute}`
    setlastUpdated(lastUpdate)
  }

  if (!shortDesc) {
    loadData()
  }

  useEffect(() => {
    // load currency for the first time
    loadCurrency()
    loadLastUpdated()

    // refresh currency every 15 minutes
    const interval = setInterval(() => {
      loadCurrency()
      loadLastUpdated()
    }, 900000)
    return () => clearInterval(interval)
  }, [])

  const formatValue = (num, withDot = false) => {
    if (withDot === false) {
      const deleteDot = num.substring(0, num.indexOf('.'))
      const sliceNum = Number(deleteDot.slice(0, 5).toString())
      let formatNumber = ''
      let number = sliceNum.toString().split('').reverse().join('')
      for (let i = 0; i < number.length; i++)
        if (i % 3 === 0) formatNumber += number.substr(i, 3) + '.'
      return formatNumber
        .split('', formatNumber.length - 1)
        .reverse()
        .join('')
    } else {
      let rightDot = num.substring(num.indexOf('.'), num.indexOf('.') + 3)
      let leftDot = num.substring(0, num.indexOf('.'))
      rightDot = rightDot.replace('.', ',')
      return leftDot + rightDot
    }
  }

  return (
    <CurrencyContainer>
      <LeadingTitle
        title={t('info_kurs')}
        subtitle={shortDesc !== null ? shortDesc[0].description : ''}
      />

      <div className="currency-info-content">
        <div className="filter-box">
          <CurrencyExchange />
        </div>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingBottom: '20px',
          }}
        >
          <i>
            {t('terakhir_diperbarui')} {lastUpdated}
          </i>
        </div>

        <div className="content-box">
          <ul className="nav nav-underline mb-3" id="pills-tab" role="tablist">
            <li className="nav-item flex-grow-1" role="presentation">
              <button
                className="nav-link w-100 active"
                id="pills-obligasi-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-obligasi"
                type="button"
                role="tab"
                aria-controls="pills-obligasi"
                aria-selected="true"
              >
                {t('informasi_kurs_tt')}
              </button>
            </li>
            <li className="nav-item flex-grow-1" role="presentation">
              <button
                className="nav-link w-100"
                id="pills-saham-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-saham"
                type="button"
                role="tab"
                aria-controls="pills-saham"
                aria-selected="false"
              >
                {t('informasi_kurs_bank_note')}
              </button>
            </li>
          </ul>
          <div className="tab-content" id="pills-tabContent">
            <div
              className="tab-pane fade show active"
              id="pills-obligasi"
              role="tabpanel"
              aria-labelledby="pills-obligasi-tab"
            >
              <div className="table-box">
                <Table bordered className="table-striped-custom">
                  <thead>
                    <tr className="border-0">
                      <th className="border-0">{t('currency')}</th>
                      <th className="border-0">{t('sell')}</th>
                      <th className="border-0">{t('buy')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currencySGD.length !== 0 ? (
                      currencySGD.map((data, i) => {
                        return (
                          <tr key={i} className="border-0">
                            <td className="border-0 pl-custom">
                              <div className="mata-uang">
                                <div className="icon-flag">
                                  <img
                                    className="rounded-circle shadow bg-white me-2 icon"
                                    src="https://www.countryflags.com/wp-content/uploads/singapore-flag-png-large.png"
                                    alt=""
                                  />
                                </div>
                                SGD
                              </div>
                            </td>
                            <td className="border-0">
                              {formatValue(data.ttSel)}
                            </td>
                            <td className="border-0">
                              {formatValue(data.ttBuy)}
                            </td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr className="border-0">
                        <td className="border-0 pl-custom">
                          <div className="mata-uang">
                            <div className="icon-flag">
                              <img
                                className="rounded-circle shadow bg-white me-2 icon"
                                src="https://www.countryflags.com/wp-content/uploads/singapore-flag-png-large.png"
                                alt=""
                              />
                            </div>
                            SGD
                          </div>
                        </td>
                        <td className="border-0">-</td>
                        <td className="border-0">-</td>
                      </tr>
                    )}
                    {currencyUSD.length !== 0 ? (
                      currencyUSD.map((data, i) => {
                        return (
                          <tr key={i} className="border-0">
                            <td className="border-0 pl-custom">
                              <div className="mata-uang">
                                <div className="icon-flag">
                                  <img
                                    className="rounded-circle shadow bg-white me-2 icon"
                                    src="https://www.countryflags.com/wp-content/uploads/united-states-of-america-flag-png-large.png"
                                    alt=""
                                  />
                                </div>
                                USD
                              </div>
                            </td>
                            <td className="border-0">
                              {formatValue(data.ttSel)}
                            </td>
                            <td className="border-0">
                              {formatValue(data.ttBuy)}
                            </td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr className="border-0">
                        <td className="border-0 pl-custom">
                          <div className="mata-uang">
                            <div className="icon-flag">
                              <img
                                className="rounded-circle shadow bg-white me-2 icon"
                                src="https://www.countryflags.com/wp-content/uploads/united-states-of-america-flag-png-large.png"
                                alt=""
                              />
                            </div>
                            USD
                          </div>
                        </td>
                        <td className="border-0">-</td>
                        <td className="border-0">-</td>
                      </tr>
                    )}
                    {currencyEUR.length !== 0 ? (
                      currencyEUR.map((data, i) => {
                        return (
                          <tr key={i} className="border-0">
                            <td className="border-0 pl-custom">
                              <div className="mata-uang">
                                <div className="icon-flag">
                                  <img
                                    className="rounded-circle shadow bg-white me-2 icon"
                                    src="https://www.countryflags.com/wp-content/uploads/europe-flag-jpg-xl-768x512.jpg"
                                    alt=""
                                  />
                                </div>
                                EUR
                              </div>
                            </td>
                            <td className="border-0">
                              {formatValue(data.ttSel)}
                            </td>
                            <td className="border-0">
                              {formatValue(data.ttBuy)}
                            </td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr className="border-0">
                        <td className="border-0 pl-custom">
                          <div className="mata-uang">
                            <div className="icon-flag">
                              <img
                                className="rounded-circle shadow bg-white me-2 icon"
                                src="https://www.countryflags.com/wp-content/uploads/europe-flag-jpg-xl-768x512.jpg"
                                alt=""
                              />
                            </div>
                            EUR
                          </div>
                        </td>
                        <td className="border-0">-</td>
                        <td className="border-0">-</td>
                      </tr>
                    )}
                    {currencyAUD.length !== 0 ? (
                      currencyAUD.map((data, i) => {
                        return (
                          <tr key={i} className="border-0">
                            <td className="border-0 pl-custom">
                              <div className="mata-uang">
                                <div className="icon-flag">
                                  <img
                                    className="rounded-circle shadow bg-white me-2 icon"
                                    src="https://www.countryflags.com/wp-content/uploads/australia-australian-flag-png-square-large.png"
                                    alt=""
                                  />
                                </div>
                                AUD
                              </div>
                            </td>
                            <td className="border-0">
                              {formatValue(data.ttSel)}
                            </td>
                            <td className="border-0">
                              {formatValue(data.ttBuy)}
                            </td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr className="border-0">
                        <td className="border-0 pl-custom">
                          <div className="mata-uang">
                            <div className="icon-flag">
                              <img
                                className="rounded-circle shadow bg-white me-2 icon"
                                src="https://www.countryflags.com/wp-content/uploads//australia-australian-flag-png-square-large.png"
                                alt=""
                              />
                            </div>
                            AUD
                          </div>
                        </td>
                        <td className="border-0">-</td>
                        <td className="border-0">-</td>
                      </tr>
                    )}
                    {currencyHKD.length !== 0 ? (
                      currencyHKD.map((data, i) => {
                        return (
                          <tr key={i} className="border-0">
                            <td className="border-0 pl-custom">
                              <div className="mata-uang">
                                <div className="icon-flag">
                                  <img
                                    className="rounded-circle shadow bg-white me-2 icon"
                                    src="https://www.countryflags.com/wp-content/uploads/hongkong-flag-jpg-xl.jpg"
                                    alt=""
                                  />
                                </div>
                                HKD
                              </div>
                            </td>
                            <td className="border-0">
                              {formatValue(data.ttSel)}
                            </td>
                            <td className="border-0">
                              {formatValue(data.ttBuy)}
                            </td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr className="border-0">
                        <td className="border-0 pl-custom">
                          <div className="mata-uang">
                            <div className="icon-flag">
                              <img
                                className="rounded-circle shadow bg-white me-2 icon"
                                src="https://www.countryflags.com/wp-content/uploads/hongkong-flag-jpg-xl.jpg"
                                alt=""
                              />
                            </div>
                            HKD
                          </div>
                        </td>
                        <td className="border-0">-</td>
                        <td className="border-0">-</td>
                      </tr>
                    )}
                    {currencyJPY.length !== 0 ? (
                      currencyJPY.map((data, i) => {
                        return (
                          <tr key={i} className="border-0">
                            <td className="border-0 pl-custom">
                              <div className="mata-uang">
                                <div className="icon-flag">
                                  <img
                                    className="rounded-circle shadow bg-white me-2 icon"
                                    src="https://www.countryflags.com/wp-content/uploads/japan-flag-png-large.png"
                                    alt=""
                                  />
                                </div>
                                JPY
                              </div>
                            </td>
                            <td className="border-0">{formatValue(data.ttSel, true)}</td>
                            <td className="border-0">{formatValue(data.ttBuy, true)}</td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr className="border-0">
                        <td className="border-0 pl-custom">
                          <div className="mata-uang">
                            <div className="icon-flag">
                              <img
                                className="rounded-circle shadow bg-white me-2 icon"
                                src="https://www.countryflags.com/wp-content/uploads/japan-flag-png-large.png"
                                alt=""
                              />
                            </div>
                            JPY
                          </div>
                        </td>
                        <td className="border-0">-</td>
                        <td className="border-0">-</td>
                      </tr>
                    )}
                    {currencyCNY.length !== 0 ? (
                      currencyCNY.map((data, i) => {
                        return (
                          <tr key={i} className="border-0">
                            <td className="border-0 pl-custom">
                              <div className="mata-uang">
                                <div className="icon-flag">
                                  <img
                                    className="rounded-circle shadow bg-white me-2 icon"
                                    src="https://www.countryflags.com/wp-content/uploads/china-flag-png-large.png"
                                    alt=""
                                  />
                                </div>
                                CNY
                              </div>
                            </td>
                            <td className="border-0">
                              {formatValue(data.ttSel)}
                            </td>
                            <td className="border-0">
                              {formatValue(data.ttBuy)}
                            </td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr className="border-0">
                        <td className="border-0 pl-custom">
                          <div className="mata-uang">
                            <div className="icon-flag">
                              <img
                                className="rounded-circle shadow bg-white me-2 icon"
                                src="https://www.countryflags.com/wp-content/uploads/china-flag-png-large.png"
                                alt=""
                              />
                            </div>
                            CNY
                          </div>
                        </td>
                        <td className="border-0">-</td>
                        <td className="border-0">-</td>
                      </tr>
                    )}
                    {currencyGBP.length !== 0 ? (
                      currencyGBP.map((data, i) => {
                        return (
                          <tr key={i} className="border-0">
                            <td className="border-0 pl-custom">
                              <div className="mata-uang">
                                <div className="icon-flag">
                                  <img
                                    className="rounded-circle shadow bg-white me-2 icon"
                                    src="https://www.countryflags.com/wp-content/uploads/united-kingdom-flag-png-large.png"
                                    alt=""
                                  />
                                </div>
                                GBP
                              </div>
                            </td>
                            <td className="border-0">
                              {formatValue(data.ttSel)}
                            </td>
                            <td className="border-0">
                              {formatValue(data.ttBuy)}
                            </td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr className="border-0">
                        <td className="border-0 pl-custom">
                          <div className="mata-uang">
                            <div className="icon-flag">
                              <img
                                className="rounded-circle shadow bg-white me-2 icon"
                                src="https://www.countryflags.com/wp-content/uploads/united-kingdom-flag-png-large.png"
                                alt=""
                              />
                            </div>
                            GBP
                          </div>
                        </td>
                        <td className="border-0">-</td>
                        <td className="border-0">-</td>
                      </tr>
                    )}
                    {currencyKRW.length !== 0 ? (
                      currencyKRW.map((data, i) => {
                        return (
                          <tr key={i} className="border-0">
                            <td className="border-0 pl-custom">
                              <div className="mata-uang">
                                <div className="icon-flag">
                                  <img
                                    className="rounded-circle shadow bg-white me-2 icon"
                                    src="https://www.countryflags.com/wp-content/uploads/south-korea-flag-png-large.png"
                                    alt=""
                                  />
                                </div>
                                KRW
                              </div>
                            </td>
                            <td className="border-0">{formatValue(data.ttSel, true)}</td>
                            <td className="border-0">{formatValue(data.ttBuy, true)}</td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr className="border-0">
                        <td className="border-0 pl-custom">
                          <div className="mata-uang">
                            <div className="icon-flag">
                              <img
                                className="rounded-circle shadow bg-white me-2 icon"
                                src="https://www.countryflags.com/wp-content/uploads/south-korea-flag-png-large.png"
                                alt=""
                              />
                            </div>
                            KRW
                          </div>
                        </td>
                        <td className="border-0">-</td>
                        <td className="border-0">-</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="pills-saham"
              role="tabpanel"
              aria-labelledby="pills-saham-tab"
            >
              <div className="table-box">
                <Table bordered className="table-striped-custom">
                  <thead>
                    <tr className="border-0">
                      <th className="border-0">{t('currency')}</th>
                      <th className="border-0">{t('sell')}</th>
                      <th className="border-0">{t('buy')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currencySGD.length !== 0 ? (
                      currencySGD.map((data, i) => {
                        return (
                          <tr key={i} className="border-0">
                            <td className="border-0 pl-custom">
                              <div className="mata-uang">
                                <div className="icon-flag">
                                  <img
                                    className="rounded-circle shadow bg-white me-2 icon"
                                    src="https://www.countryflags.com/wp-content/uploads/singapore-flag-png-large.png"
                                    alt=""
                                  />
                                </div>
                                SGD
                              </div>
                            </td>
                            <td className="border-0">
                              {formatValue(data.bankNoteSell)}
                            </td>
                            <td className="border-0">
                              {formatValue(data.bankNoteBuy)}
                            </td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr className="border-0">
                        <td className="border-0 pl-custom">
                          <div className="mata-uang">
                            <div className="icon-flag">
                              <img
                                className="rounded-circle shadow bg-white me-2 icon"
                                src="https://www.countryflags.com/wp-content/uploads/singapore-flag-png-large.png"
                                alt=""
                              />
                            </div>
                            SGD
                          </div>
                        </td>
                        <td className="border-0">-</td>
                        <td className="border-0">-</td>
                      </tr>
                    )}
                    {currencyUSD.length !== 0 ? (
                      currencyUSD.map((data, i) => {
                        return (
                          <tr key={i} className="border-0">
                            <td className="border-0 pl-custom">
                              <div className="mata-uang">
                                <div className="icon-flag">
                                  <img
                                    className="rounded-circle shadow bg-white me-2 icon"
                                    src="https://www.countryflags.com/wp-content/uploads/united-states-of-america-flag-png-large.png"
                                    alt=""
                                  />
                                </div>
                                USD
                              </div>
                            </td>
                            <td className="border-0">
                              {formatValue(data.bankNoteSell)}
                            </td>
                            <td className="border-0">
                              {formatValue(data.bankNoteBuy)}
                            </td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr className="border-0">
                        <td className="border-0 pl-custom">
                          <div className="mata-uang">
                            <div className="icon-flag">
                              <img
                                className="rounded-circle shadow bg-white me-2 icon"
                                src="https://www.countryflags.com/wp-content/uploads/united-states-of-america-flag-png-large.png"
                                alt=""
                              />
                            </div>
                            USD
                          </div>
                        </td>
                        <td className="border-0">-</td>
                        <td className="border-0">-</td>
                      </tr>
                    )}
                    {currencyEUR.length !== 0 ? (
                      currencyEUR.map((data, i) => {
                        return (
                          <tr key={i} className="border-0">
                            <td className="border-0 pl-custom">
                              <div className="mata-uang">
                                <div className="icon-flag">
                                  <img
                                    className="rounded-circle shadow bg-white me-2 icon"
                                    src="https://www.countryflags.com/wp-content/uploads/europe-flag-jpg-xl-768x512.jpg"
                                    alt=""
                                  />
                                </div>
                                EUR
                              </div>
                            </td>
                            <td className="border-0">
                              {formatValue(data.bankNoteSell)}
                            </td>
                            <td className="border-0">
                              {formatValue(data.bankNoteBuy)}
                            </td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr className="border-0">
                        <td className="border-0 pl-custom">
                          <div className="mata-uang">
                            <div className="icon-flag">
                              <img
                                className="rounded-circle shadow bg-white me-2 icon"
                                src="https://www.countryflags.com/wp-content/uploads/europe-flag-jpg-xl-768x512.jpg"
                                alt=""
                              />
                            </div>
                            EUR
                          </div>
                        </td>
                        <td className="border-0">-</td>
                        <td className="border-0">-</td>
                      </tr>
                    )}
                    {currencyAUD.length !== 0 ? (
                      currencyAUD.map((data, i) => {
                        return (
                          <tr key={i} className="border-0">
                            <td className="border-0 pl-custom">
                              <div className="mata-uang">
                                <div className="icon-flag">
                                  <img
                                    className="rounded-circle shadow bg-white me-2 icon"
                                    src="https://www.countryflags.com/wp-content/uploads/australia-australian-flag-png-square-large.png"
                                    alt=""
                                  />
                                </div>
                                AUD
                              </div>
                            </td>
                            <td className="border-0">
                              {formatValue(data.bankNoteSell)}
                            </td>
                            <td className="border-0">
                              {formatValue(data.bankNoteBuy)}
                            </td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr className="border-0">
                        <td className="border-0 pl-custom">
                          <div className="mata-uang">
                            <div className="icon-flag">
                              <img
                                className="rounded-circle shadow bg-white me-2 icon"
                                src="https://www.countryflags.com/wp-content/uploads/australia-australian-flag-png-square-large.png"
                                alt=""
                              />
                            </div>
                            AUD
                          </div>
                        </td>
                        <td className="border-0">-</td>
                        <td className="border-0">-</td>
                      </tr>
                    )}
                    {currencyHKD.length !== 0 ? (
                      currencyHKD.map((data, i) => {
                        return (
                          <tr key={i} className="border-0">
                            <td className="border-0 pl-custom">
                              <div className="mata-uang">
                                <div className="icon-flag">
                                  <img
                                    className="rounded-circle shadow bg-white me-2 icon"
                                    src="https://www.countryflags.com/wp-content/uploads/hongkong-flag-jpg-xl.jpg"
                                    alt=""
                                  />
                                </div>
                                HKD
                              </div>
                            </td>
                            <td className="border-0">
                              {formatValue(data.bankNoteSell)}
                            </td>
                            <td className="border-0">
                              {formatValue(data.bankNoteBuy)}
                            </td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr className="border-0">
                        <td className="border-0 pl-custom">
                          <div className="mata-uang">
                            <div className="icon-flag">
                              <img
                                className="rounded-circle shadow bg-white me-2 icon"
                                src="https://www.countryflags.com/wp-content/uploads/hongkong-flag-jpg-xl.jpg"
                                alt=""
                              />
                            </div>
                            HKD
                          </div>
                        </td>
                        <td className="border-0">-</td>
                        <td className="border-0">-</td>
                      </tr>
                    )}
                    {currencyJPY.length !== 0 ? (
                      currencyJPY.map((data, i) => {
                        return (
                          <tr key={i} className="border-0">
                            <td className="border-0 pl-custom">
                              <div className="mata-uang">
                                <div className="icon-flag">
                                  <img
                                    className="rounded-circle shadow bg-white me-2 icon"
                                    src="https://www.countryflags.com/wp-content/uploads/japan-flag-png-large.png"
                                    alt=""
                                  />
                                </div>
                                JPY
                              </div>
                            </td>
                            <td className="border-0">{formatValue(data.bankNoteSell, true)}</td>
                            <td className="border-0">{formatValue(data.bankNoteBuy, true)}</td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr className="border-0">
                        <td className="border-0 pl-custom">
                          <div className="mata-uang">
                            <div className="icon-flag">
                              <img
                                className="rounded-circle shadow bg-white me-2 icon"
                                src="https://www.countryflags.com/wp-content/uploads/japan-flag-png-large.png"
                                alt=""
                              />
                            </div>
                            JPY
                          </div>
                        </td>
                        <td className="border-0">-</td>
                        <td className="border-0">-</td>
                      </tr>
                    )}
                    {currencyCNY.length !== 0 ? (
                      currencyCNY.map((data, i) => {
                        return (
                          <tr key={i} className="border-0">
                            <td className="border-0 pl-custom">
                              <div className="mata-uang">
                                <div className="icon-flag">
                                  <img
                                    className="rounded-circle shadow bg-white me-2 icon"
                                    src="https://www.countryflags.com/wp-content/uploads/china-flag-png-large.png"
                                    alt=""
                                  />
                                </div>
                                CNY
                              </div>
                            </td>
                            <td className="border-0">
                              {formatValue(data.bankNoteSell)}
                            </td>
                            <td className="border-0">
                              {formatValue(data.bankNoteBuy)}
                            </td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr className="border-0">
                        <td className="border-0 pl-custom">
                          <div className="mata-uang">
                            <div className="icon-flag">
                              <img
                                className="rounded-circle shadow bg-white me-2 icon"
                                src="https://www.countryflags.com/wp-content/uploads/china-flag-png-large.png"
                                alt=""
                              />
                            </div>
                            CNY
                          </div>
                        </td>
                        <td className="border-0">-</td>
                        <td className="border-0">-</td>
                      </tr>
                    )}
                    {currencyGBP.length !== 0 ? (
                      currencyGBP.map((data, i) => {
                        return (
                          <tr key={i} className="border-0">
                            <td className="border-0 pl-custom">
                              <div className="mata-uang">
                                <div className="icon-flag">
                                  <img
                                    className="rounded-circle shadow bg-white me-2 icon"
                                    src="https://www.countryflags.com/wp-content/uploads/united-kingdom-flag-png-large.png"
                                    alt=""
                                  />
                                </div>
                                GBP
                              </div>
                            </td>
                            <td className="border-0">
                              {formatValue(data.bankNoteSell)}
                            </td>
                            <td className="border-0">
                              {formatValue(data.bankNoteBuy)}
                            </td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr className="border-0">
                        <td className="border-0 pl-custom">
                          <div className="mata-uang">
                            <div className="icon-flag">
                              <img
                                className="rounded-circle shadow bg-white me-2 icon"
                                src="https://www.countryflags.com/wp-content/uploads/united-kingdom-flag-png-large.png"
                                alt=""
                              />
                            </div>
                            GBP
                          </div>
                        </td>
                        <td className="border-0">-</td>
                        <td className="border-0">-</td>
                      </tr>
                    )}
                    {currencyKRW.length !== 0 ? (
                      currencyKRW.map((data, i) => {
                        return (
                          <tr key={i} className="border-0">
                            <td className="border-0 pl-custom">
                              <div className="mata-uang">
                                <div className="icon-flag">
                                  <img
                                    className="rounded-circle shadow bg-white me-2 icon"
                                    src="https://www.countryflags.com/wp-content/uploads/south-korea-flag-png-large.png"
                                    alt=""
                                  />
                                </div>
                                KRW
                              </div>
                            </td>
                            <td className="border-0">{formatValue(data.bankNoteSell, true)}</td>
                            <td className="border-0">{formatValue(data.bankNoteBuy, true)}</td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr className="border-0">
                        <td className="border-0 pl-custom">
                          <div className="mata-uang">
                            <div className="icon-flag">
                              <img
                                className="rounded-circle shadow bg-white me-2 icon"
                                src="https://www.countryflags.com/wp-content/uploads/south-korea-flag-png-large.png"
                                alt=""
                              />
                            </div>
                            KRW
                          </div>
                        </td>
                        <td className="border-0">-</td>
                        <td className="border-0">-</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>

        <div className="information-box">
          <div className="alert-content">
            <div className="alert-content-icon">
              <AlertCircle fill="#85714D" />
            </div>
            <p className="alert-content-desc">
              {t('alert_currency_kurs1')}
              <br />
              {t('alert_currency_kurs2')}
              <br />
              {t('alert_currency_kurs3')}
              <br />
              {t('alert_currency_kurs4')}
            </p>
          </div>
        </div>
      </div>

      <FooterSection currentPage={t('info_kurs')} />
    </CurrencyContainer>
  )
}

export default CurrencyInfo
